import React, { useContext, useEffect, useRef, useState } from "react";
import Select from "react-select";
import CssTransition from "../component/layout/css-transition";
import { UserContext } from "../service/context";
import request from "../service/request";

const CallSchedule = () => {
  const trigger = useRef(null);
  const dropdown = useRef(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const ctx = useContext(UserContext);
  const [usersList, setUsersList] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const [selectedTime, setSelectedTime] = useState("");

  useEffect(() => {
    (async () => {
      const results = await request(`/user/company`, null, "GET", ctx.user.token);
      if (Array.isArray(results.results)) {
        setUsersList(results.results);
      }
    })();
  }, []);

  const handleUserSelection = (val) => {
    setSelectedUser(val);
    setDropdownOpen(!dropdownOpen);
  };

  const handleTimeSelection = (time) => {
    setSelectedTime(time);
  };

  return (
    <div className="px-5 py-3">
      <div className="bg-white p-4 shadow-lg rounded border border-slate-200">
        <div className="text-lg font-medium">Call Scheduling</div>
        <div className="flex justify-center items-center mt-5">
          <div className="p-2">
            <div className="flex flex-col mb-4">
              <label htmlFor="users" className="font-inter font-medium text-sm leading-5 text-gray-700 mb-1">
                Select Users
              </label>
              <div className="relative inline-flex min-w-[350px]">
                <button
                  ref={trigger}
                  type="button"
                  aria-label="Select Users"
                  aria-haspopup="true"
                  onClick={() => {
                    setDropdownOpen(!dropdownOpen);
                  }}
                  aria-expanded={dropdownOpen}
                  className="btn justify-between w-full bg-white border-slate-200 hover:border-slate-300 text-slate-500 hover:text-slate-600"
                >
                  <span className="flex items-center">
                    <span>{selectedUser ? selectedUser.name : "Please select users"}</span>
                  </span>
                  <svg className="shrink-0 ml-1 fill-current text-slate-400" width="11" height="7" viewBox="0 0 11 7">
                    <path d="M5.4 6.8L0 1.4 1.4 0l4 4 4-4 1.4 1.4z" />
                  </svg>
                </button>
                <CssTransition show={dropdownOpen} tag="div" className="z-11 overflow-y-auto absolute min-h-min max-h-36 top-full left-0 w-full bg-white border border-slate-200 py-1.5 rounded shadow-lg overflow-hidden mt-1" enter="transition ease-out duration-100 transform" enterStart="opacity-0 -translate-y-2" enterEnd="opacity-100 translate-y-0" leave="transition ease-out duration-100" leaveStart="opacity-100" leaveEnd="opacity-0">
                  <div ref={dropdown} className="font-medium text-sm text-slate-600" onFocus={() => setDropdownOpen(true)} onBlur={() => setDropdownOpen(false)}>
                    {usersList.map((item) => (
                      <div
                        key={item.id}
                        tabIndex="0"
                        className={`flex items-center flex-nowrap w-full hover:bg-slate-50 py-1 px-3 cursor-pointer ${item.id === selectedUser.id && "text-[--bg-color-500]"}`}
                        onClick={(e) => {
                          e.preventDefault();
                          handleUserSelection(item);
                        }}
                      >
                        <svg className={`shrink-0 mr-2 fill-current text-[--bg-color-500] ${item.id !== selectedUser.id && "invisible"}`} width="12" height="9" viewBox="0 0 12 9">
                          <path d="M10.28.28L3.989 6.575 1.695 4.28A1 1 0 00.28 5.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28.28z" />
                        </svg>
                        <span>{item.name}</span>
                      </div>
                    ))}
                  </div>
                </CssTransition>
              </div>
              {/* {selectedError !== "" && <div className="text-rose-500 font-inter font-extralight text-xs pt-1">{selectedError}</div>} */}
            </div>
            <div className="flex flex-col mb-4">
              <label htmlFor="subject" className="font-inter font-medium text-sm leading-5 text-gray-700 mb-1">
                Agenda
              </label>

              <textarea type="text" className="form-input p-2 w-full disabled:border-slate-200" />
              {/* <div className="text-rose-500 font-inter font-extralight text-xs pt-1">{formState.errors?.remarks?.message}</div> */}
            </div>
            <div>
              <div className="flex flex-row justify-between items-center">
                <div
                  className="cursor-pointer"
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-4 h-4">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
                  </svg>
                </div>
                <div className="text-sm">9th January</div>
                <div
                  className="cursor-pointer"
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" class="w-4 h-4">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                  </svg>
                </div>
              </div>
              <div className="mt-4 flex justify-center">
                <ul>
                  {timing.map((item, index) => (
                    <li
                      key={index}
                      className={`px-10 py-1 cursor-pointer border border-slate-300 ${item === selectedTime && "bg-slate-200 text-gray-900"}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleTimeSelection(item);
                      }}
                    >
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <button type="button" className={"flex items-center btn !bg-[--bg-color-500] hover:!bg-[--bg-color-600] text-white w-full mt-5 "}>
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

CallSchedule.auth = { path: "/call-scheduling", role: "super-admin" };

export default CallSchedule;

const timing = ["02:00 - 02:15", "02:15 - 02:30", "02:30 - 02:45", "02:45 - 03:00", "03:00 - 03:15", "03:15 - 03:30", "03:30 - 03:45", "03:45 - 04:00", "04:00 - 04:15", "04:15 - 04:30", "04:30 - 04:45", "04:45 - 05:00", "05:00 - 05:15", "05:15 - 05:30", "05:30 - 05:45", "05:45 - 06:00"];
